module.exports = __webpack_public_path__ + "static/media/e- campus.b76b3d08.png";